import { AppDispatch, RootState } from "../../root-redux/RootState";
import { useDispatch, useSelector } from "react-redux";
import { UserProfileCard } from "../user-profile/UserProfileCard";
import { UserEmailComponent } from "../user-profile/userEmailComponent";
import "./app-header-styles.css";
import { Button, Icon, Tooltip, FlyInPanel } from "../../common/HarmonyEnablers";
import { NebulaSupportAgent } from "../../feature-components/nebula-support-agent/NebulaSupportAgent";
import { resetNebulaSupportAgent } from "../../feature-components/nebula-support-agent/NebulaSupportAgent.redux";
import { Dropdown } from "../../shared-components/dropdown-filter/DropdownFilterScope";
import { NavMenuItemType } from "../../model/NavMenu.model";
import { useNavigate } from "react-router-dom";
import { setShowDialog } from "../../shared-components/feedback/Feedback.redux";
import { NebulaInformation } from "../nebula-info/NebulaInformationCard";
import { useState, useRef, useEffect, useCallback } from "react";
import  HelpContent  from "../../feature-components/workflows/help-workflows/HelpContent";

export const AppHeader: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const stateProps = useSelector((state: RootState) => ({
    selectedNavItem: state.nav.selectedNavItem,
    selectedEnvItem: state.env.selectedEnvItem,
    isNavPanelOpen: state.nav.isNavPanelOpen,
    selectedAppPersonaItem: state.appPersonas.list,
    userEmail: state.userDetails.username,
  }));
  const navigate = useNavigate();
  const [openHelpPanel, setOpenHelpPanel] = useState(false);
  const [openAgentPanel, setOpenAgentPanel] = useState(false);
  const [agentResetKey, setAgentResetKey] = useState(0);
  const agentPanelRef = useRef<any>(null);

  const handleNewSession = useCallback(() => {
    dispatch(resetNebulaSupportAgent());
    setAgentResetKey(k => k + 1);
  }, [dispatch]);

  // Inject a refresh button into the FlyInPanel header, right before the close (X) button
  useEffect(() => {
    if (!openAgentPanel) return;
    const host = agentPanelRef.current;
    const inject = () => {
      const shadow = host?.shadowRoot;
      if (!shadow) return;
      // Don't inject button twice
      if (shadow.querySelector("#nebula-new-session-btn")) return;
      const closeBtn = shadow.querySelector(".fly-in__close");
      if (!closeBtn) return;
      const btn = document.createElement("button");
      btn.id = "nebula-new-session-btn";
      btn.title = "New Session";
      // Match the he-button close button's box model: stealth buttons have --padding-x: var(--he-spacing-x-small) internal padding
      btn.setAttribute("style",
        "background:none;border:none;cursor:pointer;padding:var(--he-spacing-x-small);margin:0;display:flex;align-items:center;justify-content:center;flex:0 0 auto;font-size:var(--he-font-size-large);opacity:0.7;"
      );
      btn.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1.5a6.5 6.5 0 1 0 6.5 6.5h-1A5.5 5.5 0 1 1 8 2.5V1.5z"/><path d="M8 5V1l3.5 2L8 5z"/></svg>`;
      btn.addEventListener("click", () => {
        host.dispatchEvent(new CustomEvent("nebula-new-session"));
      });
      closeBtn.parentNode?.insertBefore(btn, closeBtn);
    };
    inject();
    const t = setTimeout(inject, 100);
    return () => clearTimeout(t);
  }, [openAgentPanel]);

  // Listen for the custom event from the injected button
  useEffect(() => {
    const host = agentPanelRef.current;
    if (!host) return;
    const handler = () => handleNewSession();
    host.addEventListener("nebula-new-session", handler);
    return () => host.removeEventListener("nebula-new-session", handler);
  }, [handleNewSession]);

  const envMap = {
    uat: "Staging",
    prod: "Production",
  };

  return (
    <>
      <div className="app-header-wrapper">
        <div className="app-header">
          <div className="app-header-title">
            <span
              style={{
                fontWeight: "600",
                color: "white",
                cursor: "pointer",
                fontSize: "18px",
              }}
              onClick={() =>
                navigate("/" + NavMenuItemType[NavMenuItemType.Home])
              }
            >
              Nebula
            </span>
            <span 
              id = "appenvironment"
              style={{
                fontWeight: "500",
                color: "white",
                marginLeft: "6px",
                fontSize: "14px",
              }}
            >
               |{" "}
              {stateProps.selectedEnvItem
                ? envMap[stateProps.selectedEnvItem as "uat" | "prod"]
                : ""}
            </span>
          </div>
          <div className="app-header-actions">

            <div style={{ display: "flex", flexDirection: "row" }}>
              <div>
                <Button
                  appearance="stealth"
                  className="headerButton"
                  onClick={() => setOpenAgentPanel(!openAgentPanel)}
                  id="nebulaagentappheader"
                >
                  <Icon
                    name="robot"
                    label="Nebula Support Agent"
                    style={{ color: "white" }}
                  />
                  <Tooltip anchor="nebulaagentappheader">Nebula Support Agent</Tooltip>
                </Button>
              </div>
              <div>
                <Dropdown fixed-placement>
                  <Button
                    slot="trigger"
                    appearance="stealth"
                    className="headerButton"
                    onClick={() => {
                      setOpenHelpPanel(!openHelpPanel);
                    }}
                    id = "helpappheader"
                  >
                    <Icon
                      name="help"
                      label="help"
                      style={{ color: "white" }}
                    >
                      {" "}
                    </Icon>
                    <Tooltip anchor="helpappheader">Help</Tooltip>
                  </Button>
                </Dropdown>
              </div>

              <div>
                <Button
                  appearance="stealth"
                  className="headerButton"
                  onClick={() => dispatch(setShowDialog(true))}
                  id = "nebulafeedbackappheader"
                >
                  <Icon
                    name="feedback"
                    label="feedback"
                    style={{ color: "white" }}
                  ></Icon>
                </Button>
              </div>

              <div>
                <Dropdown fixed-placement>
                  <Button
                    slot="trigger"
                    appearance="stealth"
                    className="headerButton"
                    id = "userprofileappheader"
                  >
                    <UserEmailComponent />
                  </Button>
                  <UserProfileCard />
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <HelpContent
          openHelpPanel={openHelpPanel}
          setOpenHelpPanel={setOpenHelpPanel}
        />
      </div>
      <FlyInPanel
        ref={agentPanelRef}
        open={openAgentPanel}
        heading="Nebula Support Agent"
        onHeHide={() => setOpenAgentPanel(false)}
        style={{ "--size": "550px" } as any}
      >
        <NebulaSupportAgent resetKey={agentResetKey} onNewSession={handleNewSession} />
      </FlyInPanel>
    </>
  );
};
